var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-container',{attrs:{"fluid":""}},[_c('d-row',[_c('main',{staticClass:"main-content col-lg-12 col-md-12 col-sm-12 p-0"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }